import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withContext, Theme, getMarginBottomClass, detectBrowser, IconStatusConfirmationOnlight, marginBottomLevels } from '@piggybank/core';
import { Consumer } from '../Wizard/context.js';
import get from 'lodash/fp/get';
import styles from './progress-indicator.css.js';
var inDevelopment = get('env.NODE_ENV', process) === 'development';

var ProgressIndicator = /*#__PURE__*/function (_Component) {
  _inherits(ProgressIndicator, _Component);

  function ProgressIndicator(props) {
    var _this;

    _classCallCheck(this, ProgressIndicator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressIndicator).call(this, props));
    _this.state = {
      mounted: !_this.props.last
    };
    return _this;
  }

  _createClass(ProgressIndicator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.last) {
        setTimeout(function () {
          _this2.setState({
            mounted: true
          });
        }, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          current = _this$props.current,
          last = _this$props.last,
          textMap = _this$props.textMap,
          renderStepText = _this$props.renderStepText,
          marginBottom = _this$props.marginBottom,
          total = _this$props.total,
          stageTitles = _this$props.stageTitles,
          props = _objectWithoutProperties(_this$props, ["current", "last", "textMap", "renderStepText", "marginBottom", "total", "stageTitles"]);

      var pages = Array.apply(null, {
        length: total
      }).map(Number.call, Number);

      if (inDevelopment && stageTitles && stageTitles.length != total) {
        throw new Error("[WARNING]: ProgressIndicator - When using stageTitles you must provide a title for each step\n      (The length of stageTitle array must equal the value of total prop)");
      }

      var progressCounter = Theme.select({
        redbrand: false,
        mands: true
      });
      return React.createElement("div", _extends({
        className: cn('ProgressIndicator', getMarginBottomClass(marginBottom)),
        "aria-live": detectBrowser.iOS ? false : 'polite',
        "aria-atomic": detectBrowser.iOS ? false : 'true'
      }, props), React.createElement("div", {
        className: styles.labelWrapper
      }, stageTitles && stageTitles[current - 1] && React.createElement("span", null, React.createElement("span", {
        className: styles.stageTitle
      }, "".concat(stageTitles[current - 1])), React.createElement("span", {
        className: styles.stageTitleDivider,
        role: "none"
      }, " | ")), renderStepText ? renderStepText({
        current: current,
        total: total
      }) : React.createElement(React.Fragment, null, React.createElement("span", {
        className: cn(_defineProperty({}, styles.stepLabel, !stageTitles))
      }, textMap.step), " ".concat(current, " ").concat(textMap.of, " ").concat(total))), React.createElement("div", {
        className: styles.progressWrapper,
        "aria-hidden": "true"
      }, progressCounter && React.createElement("ul", {
        className: styles.counter
      }, pages.map(function (n, i) {
        return React.createElement("li", {
          className: [styles.counter__item, n < current ? "".concat(styles.counter__item, "--active") : "".concat(styles.counter__item, "--inactive")].join(' ') // not a unique proper key albeit will not change?
          ,
          key: n + 1,
          style: {
            left: "calc(".concat(100 / (total - 1) * i, "% - 22px)")
          }
        }, React.createElement("span", {
          className: [n < current ? "".concat(styles.counter__item, "Wrapper") : "".concat(styles.counter__item, "Wrapper")].join(' ')
        }, React.createElement("span", {
          className: styles.counter__inner
        }, i + 1 < current ? React.createElement("span", {
          className: styles.counter__icon
        }, React.createElement(IconStatusConfirmationOnlight, {
          width: "24px",
          marginBottom: 0
        })) : i + 1)));
      })), React.createElement("div", {
        className: styles.bar
      }, React.createElement("div", {
        className: styles.indicator,
        style: progressCounter ? {
          transform: "translateX(".concat(-(100 - 100 / (total - 1) * (current - 1)), "%)")
        } : {
          transform: "translateX(".concat(((this.state.mounted ? current : last) / total - 1) * 100, "%)")
        }
      }))));
    }
  }]);

  return ProgressIndicator;
}(Component);

ProgressIndicator.displayName = 'ProgressIndicator';
ProgressIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  /** docgen-from-context:<Wizard/> */
  current: PropTypes.number.isRequired,

  /** docgen-from-context:<Wizard/> */
  last: PropTypes.number,
  textMap: PropTypes.shape({
    step: PropTypes.node,
    of: PropTypes.node
  }),
  renderStepText: PropTypes.func,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),

  /** docgen-from-context:<Wizard/> */
  total: PropTypes.number.isRequired,
  stageTitles: PropTypes.arrayOf(PropTypes.string)
} : {};
ProgressIndicator.defaultProps = {
  marginBottom: 4,
  textMap: {
    step: 'Step',
    of: 'of'
  }
};
var ProgressIndicator$1 = withContext(Consumer, function (value) {
  return {
    current: typeof value.currentPage === 'number' ? value.currentPage + 1 : undefined,
    last: typeof value.lastVisitedPage === 'number' ? value.lastVisitedPage + 1 : undefined,
    total: value.totalPages
  };
})(ProgressIndicator);
export default ProgressIndicator$1;
export { ProgressIndicator };